import styled from 'styled-components';
import styleUtils from '../../styles/style.utils';
import themedColor from '../../styles/theme/themed-color';
import themedFontSize, {
  themedLineHeight
} from '../../styles/theme/themed-font-size';
import mediaBreakpoints from '../../styles/media-breakpoints';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  margin: 0 auto;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  max-height: ${styleUtils.px(30)};
  max-width: ${styleUtils.px(90)};

  ${mediaBreakpoints.greaterThan('XS')`    
    max-height: ${styleUtils.px(60)};
    max-width: ${styleUtils.px(180)};  
  `};
`;

const Arrow = styled.div`
  width: ${styleUtils.px(12)};
  height: ${styleUtils.px(12)};
  border-right: ${styleUtils.px(3)} solid ${themedColor('ARROW')};
  border-top: ${styleUtils.px(3)} solid ${themedColor('ARROW')};
  margin: 0 ${styleUtils.px(16)};
  transform: rotate(45deg);

  ${mediaBreakpoints.greaterThan('XS')`    
    border-right: ${styleUtils.px(5)} solid ${themedColor('ARROW')};
    border-top: ${styleUtils.px(5)} solid ${themedColor('ARROW')};
    width: ${styleUtils.px(24)};
    height: ${styleUtils.px(24)};
    margin: 0 ${styleUtils.px(72)};
  `};
`;

const Description = styled.p`
  &.ucf-paragraph {
    color: ${themedColor('TEXT_BLUE')};
    font-size: ${themedFontSize('HEADER_CONTENT')};
    line-height: ${themedLineHeight(undefined, 'HEADER_CONTENT')};
    text-align: center;
    margin: ${styleUtils.px(36)} ${styleUtils.px(16)} 0;
    font-weight: 500;

    strong {
      font-weight: 700;
    }
    ${mediaBreakpoints.greaterThan('XS')`
      white-space: pre;    
    `};
  }
`;

const RedirectPageComponents = {
  Container,
  LogoContainer,
  Logo,
  Arrow,
  Description
};

export default RedirectPageComponents;
